import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  EoAllPermissionsDirective,
  EoAnyPermissionsDirective,
  EoNorPermissionsDirective,
  EoPermissionDirective,
  EoXorPermissionsDirective,
} from './directives';
import { EoAutoCompleteComponent } from './form/eo-autocomplete/eo-autocomplete.component';
import { EoBaseFormControlComponent } from './form/eo-base-form-control/eo-base-form-control.component';
import { EoCheckboxComponent } from './form/eo-checkbox/eo-checkbox.component';
import { EoCityDropdownComponent } from './form/eo-city-dropdown/eo-city-dropdown.component';
import { EoCountryDropdownComponent } from './form/eo-country-dropdown/eo-country-dropdown.component';
import { EoDatePickerComponent } from './form/eo-date-picker/eo-date-picker.component';
import { EoDropdownComponent } from './form/eo-dropdown/eo-dropdown.component';
import { EoFileUploadAdvancedComponent } from './form/eo-file-upload-advanced/eo-file-upload-advanced.component';
import { EoFileUploadBaseComponent } from './form/eo-file-upload-base/eo-file-upload-base.component';
import { EoFileUploadComponent } from './form/eo-file-upload/eo-file-upload.component';
import { EoFormPanelComponent } from './form/eo-form-panel/eo-form-panel.component';
import { EoFormComponent } from './form/eo-form/eo-form.component';
import { EoInputComponent } from './form/eo-input/eo-input.component';
import { EoMultiselectComponent } from './form/eo-multiselect/eo-multiselect.component';
import { EoPickListComponent } from './form/eo-pick-list/eo-pick-list.component';
import { EoPrefectureDropdownComponent } from './form/eo-prefecture-dropdown/eo-prefecture-dropdown.component';
import { EoRadiobuttonComponent } from './form/eo-radiobutton/eo-radiobutton.component';
import { EoRichtextComponent } from './form/eo-richtext/eo-richtext.component';
import { EoSpecialtyDropdownComponent } from './form/eo-specialty-dropdown/eo-specialty-dropdown.component';
import { EoTableFieldComponent } from './form/eo-table-field/eo-table-field.component';
import { EoTableFieldFormPanelComponent } from './form/eo-table-field/partial/eo-table-field-form-panel/eo-table-field-form-panel.component';
import { EoTableFieldFormComponent } from './form/eo-table-field/partial/eo-table-field-form/eo-table-field-form.component';
import { EoTextAreaComponent } from './form/eo-textarea/eo-textarea.component';
import { EoTreeDropdownComponent } from './form/eo-tree-dropdown/eo-tree-dropdown.component';
import { EoUserDropdownComponent } from './form/eo-user-dropdown/eo-user-dropdown.component';
import { EoFormHelpMsgComponent } from './form/shared/eo-form-help-msg/eo-form-help-msg.component';
import { EoFormLabelComponent } from './form/shared/eo-form-label/eo-form-label.component';
import { EoMaxLengthCounterMsgComponent } from './form/shared/eo-max-length-counter-msg/eo-max-length-counter-msg.component';
import { EoValidationErrorMsgComponent } from './form/shared/eo-validation-error-msg/eo-validation-error-msg.component';
import { EoSearchPageComponent } from './pages/eo-search-page/eo-search-page.component';
import { EoActionMenuButtonComponent } from './partial/eo-action-menu-button/eo-action-menu-button.component';
import { EoBreadcrumbComponent } from './partial/eo-breadcrumb/eo-breadcrumb.component';
import { EoFormDialogComponent } from './partial/eo-form-dialog/eo-form-dialog.component';
import { EoFormGroupListComponent } from './partial/eo-form-group-list/eo-form-group-list.component';
import { EoFormTableComponent } from './partial/eo-form-table/eo-form-table.component';
import { EoPaginatorComponent } from './partial/eo-paginator/eo-paginator.component';
import { EoSearchPanelComponent } from './partial/eo-search-panel/eo-search-panel.component';
import { EoSplitCol } from './partial/eo-split-layout/eo-split-col.directive';
import { EoSplitLayoutComponent } from './partial/eo-split-layout/eo-split-layout.component';
import { EoStepperComponent } from './partial/eo-stepper/eo-stepper.component';
import { EoTabsComponent } from './partial/eo-tabs/eo-tabs.component';
import { PrimengModule } from './primeng.module';
import { EoBaseTableComponent } from './table/eo-base-table/eo-base-table.component';
import { EoTableRowExpansionComponent } from './table/eo-table-row-expansion/eo-table-row-expansion.component';
import { EoTableComponent } from './table/eo-table/eo-table.component';
import { EoBaseViewComponent } from './view/eo-base-view/eo-base-view.component';
import { EoCurrencyComponent } from './view/eo-currency/eo-currency.component';
import { EoDateComponent } from './view/eo-date/eo-date.component';
import { EoDetailItemComponent } from './view/eo-detail-item/eo-detail-item.component';
import { EoDetailPanelComponent } from './view/eo-detail-panel/eo-detail-panel.component';
import { EoLabelComponent } from './view/eo-label/eo-label.component';
import { EoTextComponent } from './view/eo-text/eo-text.component';
import { EoViewPanelComponent } from './view/eo-view-panel/eo-view-panel.component';

@NgModule({
  declarations: [
    EoBaseFormControlComponent,
    EoValidationErrorMsgComponent,
    EoFormHelpMsgComponent,
    EoFormLabelComponent,
    EoMaxLengthCounterMsgComponent,
    EoInputComponent,
    EoTextAreaComponent,
    EoDropdownComponent,
    EoAutoCompleteComponent,
    EoFileUploadBaseComponent,
    EoFileUploadComponent,
    EoFileUploadAdvancedComponent,
    EoBaseViewComponent,
    EoTextComponent,
    EoCountryDropdownComponent,
    EoDateComponent,
    EoLabelComponent,
    EoCurrencyComponent,
    EoTableComponent,
    EoBaseTableComponent,
    EoDatePickerComponent,
    EoSpecialtyDropdownComponent,
    EoPrefectureDropdownComponent,
    EoCityDropdownComponent,
    EoPickListComponent,
    EoUserDropdownComponent,
    EoTableRowExpansionComponent,
    EoFormPanelComponent,
    EoViewPanelComponent,
    EoFormComponent,
    EoSplitCol,
    EoSplitLayoutComponent,
    EoSearchPanelComponent,
    EoSearchPageComponent,
    EoActionMenuButtonComponent,
    EoCheckboxComponent,
    EoRadiobuttonComponent,
    EoPaginatorComponent,
    EoStepperComponent,
    EoTabsComponent,
    EoFormTableComponent,
    EoFormGroupListComponent,
    EoRichtextComponent,
    EoMultiselectComponent,
    EoTableFieldComponent,
    EoTableFieldFormComponent,
    EoTableFieldFormPanelComponent,
    EoBreadcrumbComponent,
    EoFormDialogComponent,
    EoDetailItemComponent,
    EoDetailPanelComponent,
    EoTreeDropdownComponent,
    EoPermissionDirective,
    EoXorPermissionsDirective,
    EoNorPermissionsDirective,
    EoAllPermissionsDirective,
    EoAnyPermissionsDirective,
  ],
  imports: [
    CommonModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  exports: [
    EoInputComponent,
    EoTextAreaComponent,
    EoDropdownComponent,
    EoAutoCompleteComponent,
    EoCountryDropdownComponent,
    EoFileUploadComponent,
    EoFileUploadAdvancedComponent,
    EoDateComponent,
    EoTextComponent,
    EoLabelComponent,
    EoCurrencyComponent,
    EoTableComponent,
    EoDatePickerComponent,
    EoSpecialtyDropdownComponent,
    EoPrefectureDropdownComponent,
    EoCityDropdownComponent,
    EoPickListComponent,
    EoUserDropdownComponent,
    EoTableRowExpansionComponent,
    EoViewPanelComponent,
    EoFormPanelComponent,
    EoFormComponent,
    EoSplitCol,
    EoSplitLayoutComponent,
    EoSearchPanelComponent,
    EoSearchPageComponent,
    EoActionMenuButtonComponent,
    EoCheckboxComponent,
    EoRadiobuttonComponent,
    EoPaginatorComponent,
    EoStepperComponent,
    EoTabsComponent,
    EoFormTableComponent,
    EoFormGroupListComponent,
    EoTableFieldComponent,
    EoBreadcrumbComponent,
    EoFormDialogComponent,
    EoDetailItemComponent,
    EoDetailPanelComponent,
    EoTreeDropdownComponent,
    EoPermissionDirective,
    EoXorPermissionsDirective,
    EoNorPermissionsDirective,
    EoAllPermissionsDirective,
    EoAnyPermissionsDirective,
  ],
})
export class NgxEoWebComponentsModule {}
